module.exports = __webpack_public_path__ + "static/media/ajay ji_page-0001.3e35d001.jpg";